export default {
  getSupportCarList: '/v3/recruit/supplier/supportCar/list'
}
